import { bestsellerIcon, ingridientsIcon, regimenIcon, routineIcon, settingsIcon } from '@/assets/prompts-icons';
import { TranslationsType } from '@/modules/common';
import { EventType } from '@/modules/models';

export const config = {
  projectName: 'ORLO',
  apiKey:
    'b3Jsbzpza19saXZlX1R3N2ZhT0xNeEVKSjBXZFV6eWZ6SWN2Q2NPNjNJV0gwM0xjRnVDZU1WZkVoVjlQd0VnRGhRMVRyaXNXa3g3VGZBRGZsak85NDNxRVBVa0ZTWHlGMHlhU0M4SDI0a25KS3RNUkhNTEtuRzl0NTF1NjFlSVA0dGZnVm4zZUZYUkZUTVNXRXRkdXBPQ09ocGlJNE9xckloVjFWYVRlUUhNakNZVTJwNDhtZkJU',
  apiUrl: 'https://saywhatt-frj5cmaowa-uk.a.run.app',
  translations: {
    inputPlaceholder: 'Ask me anything',
  } as TranslationsType,
  prompts: [
    {
      caption: 'Recommend product',
      iconSvg: regimenIcon,
      translationId: '',
    },
    {
      caption: 'Ingredients',
      iconSvg: ingridientsIcon,
      translationId: '',
    },
    {
      caption: 'Why us?',
      iconSvg: bestsellerIcon,
      translationId: '',
    },

    {
      caption: 'Routine',
      iconSvg: routineIcon,
      translationId: '',
    },
    {
      caption: 'Women’s Vitality Mix',
      iconSvg: settingsIcon,
      translationId: '',
    },
  ],
  theme: {
    colors: {
      light: '#C5E6DC',
      dark: '#006B43',
    },

    messageText: {
      ml: {
        '.product-button': {
          color: '#ffffff',
          background: '#000000',
        },
      },
      user: {
        color: '#000000 !important',
      },
    },

    container: {
      mobile: {
        height: '100%',
      },
    },

    input: {
      styles: {
        fontFamily: 'var(--font-body-family)',
      },
    },

    messages: {
      styles: {
        fontFamily: 'var(--font-body-family)',
      },
    },
    embeddedPage: {
      global: {
        '#saywhatt-page': {
          marginTop: '-40px',
          marginBottom: '-52px',
          height: 'calc(100dvh - 45px)',
        },
        '#saywhatt-page *': {
          fontFamily: 'var(--font-body-family)',
        },
        '.needsclick': {
          display: 'none !important',
        },
      },
      wrapper: {
        mobile: {
          backgroundPosition: '80% bottom',
        },
      },
      content: {
        mobile: {
          paddingTop: '125px',
        },
      },
      heading: {
        styles: {
          textTransform: 'none',
          fontFamily: 'var(--font-heading-family) !important',
        },
      },
      input: {
        styles: {
          fontFamily: 'var(--font-body-family)',
        },
      },
    },
  },
};
